import { TOGGLE_CONFIRM_DIALOG } from './actionTypes'

import split from 'lodash/split'
import first from 'lodash/first'

const initialState = {
    visible: false,
    callback: false,
    text: '',
    title: ''
}

export default (state = initialState, action) => {
    const { type, payload } = action
    const typePrefix = first(split(type, '/'))

    switch (typePrefix) {
        case TOGGLE_CONFIRM_DIALOG:

            return !state.visible ? { visible: true, ...payload } : initialState
        default:
            return state
    }
}
